const LocalStorageService = (function () {
  var _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service
    }
    return _service
  }
  function _setToken(tokenObj) {
    localStorage.setItem('access_token', tokenObj.access_token);
    localStorage.setItem('refresh_token', tokenObj.refresh_token);
  }
  function _getAccessToken() {
    const data = JSON.parse(localStorage.getItem('login-response'))?.accessToken;
    return data;
  }

  function _getIdToken() {
    const data = document.cookie.split('; ').find(row => row.startsWith('idToken='));
    console.log("idToken ----- ............?? --->>>", data);
    return data;
  }

  function _getRefreshToken() {
    return localStorage.getItem('refresh_token');
  }
  function _clearToken() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }
  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    getIdToken: _getIdToken,
    clearToken: _clearToken
  }
})();
export default LocalStorageService;